import './PercentageProgressTask.style.less'

import PlanTaskLayout from '../../Layouts/PlanTaskLayout'

interface Prop {
  data: any
}

export function PercentageProgressTask(prop: Prop) {
  return (
    <>
      <PlanTaskLayout
        data={prop.data}
        planLabel={`Plan`}
        hasPercentage={true}
      />
    </>
  )
}
